import { render, staticRenderFns } from "./SpanLayout.vue?vue&type=template&id=372b2a08&scoped=true"
import script from "./SpanLayout.vue?vue&type=script&lang=js"
export * from "./SpanLayout.vue?vue&type=script&lang=js"
import style0 from "./SpanLayout.vue?vue&type=style&index=0&id=372b2a08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b2a08",
  null
  
)

export default component.exports